module.exports = __webpack_public_path__ + "static/media/king-sicbo.dbf6f6c4.png";